import * as Sentry from '@sentry/react';
import { RouteConfig } from '@sentry/react/build/types/reactrouter';
import { matchPath } from 'react-router-dom';
import { ROUTER_PATH } from 'router/const/routerPath.const';
import { browserHistory } from 'router/browserHistory';

const getAllRoutes = (obj: object): RouteConfig[] => {
  const routes = [];

  for (const value of Object.values(obj)) {
    if (value && typeof value === 'object') {
      routes.push(...getAllRoutes(value));
    } else {
      routes.push({ path: value });
    }
  }

  return routes;
};

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterV5BrowserTracingIntegration({
        history: browserHistory,
        routes: getAllRoutes(ROUTER_PATH),
        matchPath,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        networkRequestHeaders: ['X-Custom-Header'],
        networkResponseHeaders: ['X-Custom-Header'],
        networkDetailAllowUrls: [process.env.REACT_APP_API || '/api'],
      }),
    ],
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
  });
}
